import Close from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import TEST_ID from "enums/TEST_ID";
import { getDataTestProp } from "utils/cypressTesting";
import ScriptQrCode from "./ScriptQrCode";

type Props = {
  open: boolean;
  onClose: () => void;
  projectId: string;
  scriptId: string;
  scriptTitle?: string;
};

export default function ScriptQrDialog({
  open,
  onClose,
  projectId,
  scriptId,
  scriptTitle,
}: Props) {
  return (
    <Dialog
      {...getDataTestProp(TEST_ID.participantSignup.qrDialog)}
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ pr: 6 }}>
        Participant signup QR
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2, textAlign: "center" }}>
          Participants scan this code to open the signup form for this mobile
          script.
        </Typography>
        <ScriptQrCode
          projectId={projectId}
          scriptId={scriptId}
          title={scriptTitle}
          size={200}
        />
      </DialogContent>
    </Dialog>
  );
}
